import aggregateVariables from './aggregateVariablesHttp';
import formula from '../utils/formula.js';
import aggregateVariableDefs from '@/layouts/variables/aggregateVariableDefs';

const getAggregateVariables = (context) => {
  return new Promise((resolve, reject) => {
    aggregateVariables.getAggregateVariables(context)
      .then(response => {
        const variables = response.body.map(parseVariable);
        resolve(variables);
      }, error => {
        reject(error);
      });
  });
};

const createAggregateVariable = (context, aggregateVariable) => {
  const request = parseRequest(aggregateVariable);
  return new Promise((resolve, reject) => {
    aggregateVariables.createAggregateVariable(context, request)
      .then(response => {
        const variable = parseVariable(response.body);
        resolve(variable);
      }, error => {
        reject(error);
      });
  });
};

const updateAggregateVariable = (context, aggregateVariable) => {
  const request = parseRequest(aggregateVariable);
  return new Promise((resolve, reject) => {
    aggregateVariables.updateAggregateVariable(context, request)
      .then(response => {
        const variable = parseVariable(response.body);
        resolve(variable);
      }, error => {
        reject(error);
      });
  });
};

const deleteAggregateVariable = (context, id) => {
  return new Promise((resolve, reject) => {
    aggregateVariables.deleteAggregateVariable(context, id)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const parseRequest = (variable) => {
  const variableFormula = ((goal) => {
    switch (goal) {
      case aggregateVariableDefs.goal.metrical:
        return formula.encodeMetrical(variable);
      case aggregateVariableDefs.goal.gradual:
        return formula.encodeGradual(variable.varId, variable.timeGap);
      case aggregateVariableDefs.goal.operated:
        return formula.encode(variable);
      default:
        return null;
    }
  })(variable.goal);

  return {
    id: variable.id,
    name: variable.name,
    unit: variable.unit,
    categoryId: variable.categoryId,
    categorized: variable.categorized,
    tags: variable.tags,
    goal: variable.goal,
    owner: variable.owner,
    canEdit: variable.canEdit,
    canDelete: variable.canDelete,
    canShare: variable.canShare,
    createdAt: variable.createdAt ? variable.createdAt.getTime / 1000 : undefined,
    formula: variableFormula,
    historic: variable.historic
  };
};

const parseVariable = (aggregateVariable) => {
  const parsed = {
    id: aggregateVariable.id,
    name: aggregateVariable.name,
    unit: aggregateVariable.unit,
    categoryId: aggregateVariable.categoryId,
    categorized: aggregateVariable.categorized,
    tags: aggregateVariable.tags,
    goal: aggregateVariable.goal,
    owner: aggregateVariable.owner,
    canEdit: aggregateVariable.canEdit,
    canDelete: aggregateVariable.canDelete,
    canShare: aggregateVariable.canShare,
    createdAt: aggregateVariable.createdAt ? new Date(aggregateVariable.createdAt * 1000) : new Date()
  };

  if (aggregateVariable.goal !== aggregateVariableDefs.goal.metrical) {
    const decoded = formula.decode(aggregateVariable.formula);
    parsed['constant'] = decoded.constant;
    parsed['operator'] = decoded.operator;
    parsed['varOneId'] = decoded.varOneId;
    parsed['varTwoId'] = decoded.varTwoId;
    parsed['timeGap'] = decoded.timeGap;
  } else {
    const decoded = formula.decodeMetrical(aggregateVariable.formula);
    parsed['metrical'] = decoded.metrical;
    parsed['variableList'] = decoded.variableList;
  }
  return parsed;
};

export default {
  getAggregateVariables,
  createAggregateVariable,
  updateAggregateVariable,
  deleteAggregateVariable
};



// WEBPACK FOOTER //
// ./src/api/aggregateVariables/index.js